
export default async function ({ $auth, redirect }) {
    try {
        await $auth.fetchUser();
    } catch (e) {
        redirect('/');
    }
}